import apiService from './apiService';

const triggerApolloJob = async () => {
  try {
    const response = await apiService.batchPost(`/ProcessApolloDataManual`);
    if (typeof response === 'string') {
      return { message: response };
    }
    return response;
  } catch (error) {
    console.error('Error triggering Apollo job:', error);
    throw error;
  }
};

const triggerBPSJob = async (obtainBirthDates) => {
  try {
    const response = await apiService.batchPost(`/ProcessProspectsBPSManual`, { obtainBirthDates });
    if (typeof response === 'string') {
      return { message: response };
    }
    return response;
  } catch (error) {
    console.error('Error triggering BPS job:', error);
    throw error;
  }
};

const stopApolloJob = async () => {
  try {
    const response = await apiService.batchPost(`/StopProcessApolloDataManual`);
    if (typeof response === 'string') {
      return { message: response };
    }
    return response;
  } catch (error) {
    console.error('Error stopping Apollo job:', error);
    throw error;
  }
};

const stopBPSJob = async () => {
  try {
    const response = await apiService.batchPost(`/StopProcessProspectsBPSManual`);
    if (typeof response === 'string') {
      return { message: response };
    }
    return response;
  } catch (error) {
    console.error('Error stopping BPS job:', error);
    throw error;
  }
};

const batchService = {
  triggerApolloJob,
  triggerBPSJob,
  stopApolloJob,
  stopBPSJob
};

export default batchService;
